import styles from './DesignIssuesSolutions.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface IssuesSolutionsItem {
  issueTitle: string
  issueDescription: string
  solutionTitle: string
  solutionDescription: string
  solutionImage: string
}

const IssuesSolutions: IssuesSolutionsItem[] = [
  {
    issueTitle: '一貫性が担保されていない',
    issueDescription:
      '度重なる機能追加・改修で、UIデザインの一貫性が失われている。例えば、似たようなボタンがたくさん存在している。',
    solutionTitle: 'デザインを整理パターン化',
    solutionDescription:
      '画面遷移、レイアウト、UI部品のデザインや挙動などを整理・パターン化しアプリに反映させることで、操作性や見た目が一貫したものになり統一感のあるUXが実現できます。',
    solutionImage: '/img/services/designsystem_solution01.webp',
  },
  {
    issueTitle: 'プロダクト全体の統一感がない',
    issueDescription:
      'メインのデザイナーが変わったり、サービスごとに異なるトンマナが適用されていて、複数プロダクトの関連性が希薄。',
    solutionTitle: 'ブランド定義から丁寧に',
    solutionDescription:
      'i3DESIGNのデザインシステム制作はプロダクトにおけるブランドのあり方から定義します。はじめにきちんと言語化し、ブランドにしっかりと結びついたビジュアル表現を再定義することで、ブレのない一貫したUIデザインでプロダクトのブランド力を高めることができます。',
    solutionImage: '/img/services/designsystem_solution02.webp',
  },
  {
    issueTitle: '実装に手間が掛かり過ぎている',
    issueDescription:
      'サービスやプロダクトに変更や改修作業が発生した際に、デザインと実装作業に時間と手間がかかりすぎ困っている。',
    solutionTitle: '商用利用しやすい設計',
    solutionDescription:
      'デザイン原則をもとに、デザインガイドラインを定めます。ガイドラインに沿ったデザインパターンをコンポーネント化することで、一度デザイン・実装したものは再利用できる形になり、運用での作業工数を大きく減らすことができます。',
    solutionImage: '/img/services/designsystem_solution03.webp',
  },
]

const DesignIssuesSolutions: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.wrapper} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>よくあるデザインの課題とデザインシステムによる解決方法</h2>
      <div className={styles.inner}>
        {IssuesSolutions.map((IssuesSolution) => (
          <section className={styles.issueSolution}>
            <div className={styles.issueSolution__issue}>
              <h3 className={styles.issueSolution__issue__title}>{IssuesSolution.issueTitle}</h3>
              <p className={styles.issueSolution__issue__text}>{IssuesSolution.issueDescription}</p>
            </div>
            <img src="/img/common/arrow_down.svg" alt="" />
            <div className={styles.issueSolution__solution}>
              <h3 className={styles.issueSolution__solution__title}>{IssuesSolution.solutionTitle}</h3>
              <figure>
                <img src={IssuesSolution.solutionImage} alt={IssuesSolution.solutionTitle} />
              </figure>
              <p className={styles.issueSolution__solution__text}>{IssuesSolution.solutionDescription}</p>
            </div>
          </section>
        ))}
      </div>
    </section>
  )
}

export default DesignIssuesSolutions
